import React from 'react';
import PublicLayout from '@/components/PublicLayout';
import SEO from '@/components/SEO';
import { Button } from '@/components/ui/button';
import { GraduationCap, Award, Users, Megaphone, Calendar, Star, CheckCircle } from 'lucide-react';

const AmbassadorPage = () => (
  <PublicLayout>
    <SEO title="Campus Ambassador" description="Join the EdAssist Campus Ambassador Program. Represent India's premium education job portal at your college and earn rewards." path="/ambassador" />
    <div data-testid="ambassador-page">
      {/* Hero */}
      <section className="bg-gradient-to-br from-amber-500 via-orange-500 to-red-500 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <GraduationCap className="w-14 h-14 mx-auto mb-4 opacity-90" />
          <h1 className="text-3xl lg:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit' }}>EdAssist Campus Ambassador Program</h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">Are you passionate about education, leadership, and making a real impact in your college community?</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-16 space-y-12">
        {/* Who Can Apply */}
        <section>
          <h2 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Outfit' }}>Who Can Apply?</h2>
          <div className="grid sm:grid-cols-3 gap-4">
            {[
              { icon: GraduationCap, text: 'Enrolled in B.Ed / M.Ed / Teacher Training Programs' },
              { icon: Megaphone, text: 'Passionate about teaching and educational outreach' },
              { icon: Users, text: 'Active on campus and social media' },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3 bg-slate-50 rounded-xl p-4 border border-slate-200">
                <item.icon className="w-5 h-5 text-indigo-600 mt-0.5 flex-shrink-0" />
                <p className="text-sm text-slate-700">{item.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Why Join */}
        <section>
          <h2 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Outfit' }}>Why Join as an Ambassador?</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {[
              'Boost your resume with real-world experience',
              'Gain leadership and communication skills',
              'Get featured on EdAssist\'s website & social channels',
              'Earn certificates, rewards & recognition',
              'Work closely with a platform dedicated to educators',
            ].map((text, i) => (
              <div key={i} className="flex items-start gap-3 p-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                <p className="text-slate-700">{text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Your Role */}
        <section>
          <h2 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Outfit' }}>Your Role as an EdAssist Ambassador</h2>
          <div className="bg-indigo-50 rounded-xl border border-indigo-100 p-6">
            <ul className="space-y-3">
              {[
                'Promote EdAssist across your college and peer network',
                'Help peers register and explore the platform',
                'Enroll candidates for various upskilling certification programmes',
                'Organize / support webinars, contests, and skilling events',
                'Act as a local voice of EdAssist on campus',
              ].map((text, i) => (
                <li key={i} className="flex items-start gap-3">
                  <Star className="w-4 h-4 text-indigo-600 mt-1 flex-shrink-0" />
                  <span className="text-slate-700">{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* Perks */}
        <section>
          <h2 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Outfit' }}>Perks & Benefits</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="flex items-center gap-3 bg-amber-50 rounded-xl p-5 border border-amber-200">
              <Award className="w-6 h-6 text-amber-600 flex-shrink-0" />
              <span className="font-medium text-slate-900">Certificate of Excellence</span>
            </div>
            <div className="flex items-center gap-3 bg-pink-50 rounded-xl p-5 border border-pink-200">
              <Star className="w-6 h-6 text-pink-600 flex-shrink-0" />
              <span className="font-medium text-slate-900">Surprise goodies & social media shoutouts</span>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="text-center bg-slate-900 rounded-2xl p-10 text-white">
          <h2 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Outfit' }}>Ready to become an Ambassador?</h2>
          <p className="text-slate-300 mb-6">Limited seats only — apply early!</p>
          <a href="mailto:info@edassist.co.in">
            <Button size="lg" className="bg-white text-slate-900 hover:bg-slate-100">
              Apply Now — info@edassist.co.in
            </Button>
          </a>
        </section>
      </div>
    </div>
  </PublicLayout>
);

export default AmbassadorPage;
